import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import { selectors } from '../../infrastructure/config';
import { selectors as caseSelector } from '../../infrastructure/cases';

import AlmostTherePage from './AlmostTherePage';
import {
  saveAlmostThereForm,
  oldSignatoriesSelector,
  requestCompletedTask
} from '../../infrastructure/oldSignatories';
import { ALMOST_THERE_INFO } from '../../utils/constants';

class AlmostThereSection extends Component {
  componentDidMount() {
    if (!this.props.businessData) {
      this.props.requestCompletedTask();
    }
  }

  render() {
    const { bankId, brandId, saveAlmostThereForm, businessData, productType } = this.props;

    return (
      <AlmostTherePage
        brandId={brandId}
        bankId={bankId}
        saveAlmostThereForm={saveAlmostThereForm}
        getBusinessData={businessData}
        productType={productType}
      />
    );
  }
}

AlmostThereSection.propTypes = {
  brandId: PropTypes.brandId,
  bankId: PropTypes.bankId,
  saveAlmostThereForm: PropTypes.func.isRequired
};

const actionCreators = {
  saveAlmostThereForm,
  requestCompletedTask
};

const mapStateToProps = state => ({
  brandId: selectors.brandId(state),
  bankId: selectors.bankId(state),
  productType: caseSelector.getProductType(state),
  businessData: oldSignatoriesSelector.getBusinessData(state, ALMOST_THERE_INFO)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AlmostThereSection);
